// Levels configuration for Tap-to-Earn game
export const LEVELS_CONFIG = [
  // Levels 1-10 (Early stage)
  { level: 1, name: "Wooden Coin", tapsRequired: 5000, reward: 100000 },
  { level: 2, name: "Cracked Wood", tapsRequired: 10000, reward: 150000 },
  { level: 3, name: "Stone Coin", tapsRequired: 20000, reward: 250000 },
  { level: 4, name: "Hard Stone", tapsRequired: 35000, reward: 400000 },
  { level: 5, name: "Bronze Coin", tapsRequired: 50000, reward: 750000 },
  { level: 6, name: "Polished Bronze", tapsRequired: 75000, reward: 1200000 },
  { level: 7, name: "Iron Coin", tapsRequired: 120000, reward: 2000000 },
  { level: 8, name: "Dark Iron", tapsRequired: 180000, reward: 3000000 },
  { level: 9, name: "Steel Coin", tapsRequired: 260000, reward: 4500000 },
  { level: 10, name: "Forged Steel", tapsRequired: 400000, reward: 7000000 },
  
  // Levels 11-20 (Mid stage)
  { level: 11, name: "Silver Coin", tapsRequired: 650000, reward: 10000000 },
  { level: 12, name: "Pure Silver", tapsRequired: 1000000, reward: 15000000 },
  { level: 13, name: "Gold Coin", tapsRequired: 1500000, reward: 25000000 },
  { level: 14, name: "Polished Gold", tapsRequired: 2200000, reward: 40000000 },
  { level: 15, name: "Platinum", tapsRequired: 3200000, reward: 65000000 },
  { level: 16, name: "White Platinum", tapsRequired: 4800000, reward: 100000000 },
  { level: 17, name: "Titanium", tapsRequired: 7000000, reward: 160000000 },
  { level: 18, name: "Dark Titanium", tapsRequired: 10000000, reward: 250000000 },
  { level: 19, name: "Obsidian", tapsRequired: 15000000, reward: 400000000 },
  { level: 20, name: "Black Obsidian", tapsRequired: 22000000, reward: 650000000 },
  
  // Levels 21-30 (Late stage)
  { level: 21, name: "Crystal Coin", tapsRequired: 35000000, reward: 1000000000 },
  { level: 22, name: "Blue Crystal", tapsRequired: 50000000, reward: 1500000000 },
  { level: 23, name: "Energy Core", tapsRequired: 70000000, reward: 2200000000 },
  { level: 24, name: "Plasma Coin", tapsRequired: 95000000, reward: 3200000000 },
  { level: 25, name: "Quantum Alloy", tapsRequired: 130000000, reward: 4800000000 },
  { level: 26, name: "Nano Core", tapsRequired: 170000000, reward: 7000000000 },
  { level: 27, name: "Dark Matter", tapsRequired: 220000000, reward: 10000000000 },
  { level: 28, name: "Anti-Matter", tapsRequired: 280000000, reward: 14000000000 },
  { level: 29, name: "Singularity", tapsRequired: 350000000, reward: 20000000000 },
  { level: 30, name: "Core of Time", tapsRequired: 420000000, reward: 28000000000 },
  
  // Levels 31-40 (Endgame)
  { level: 31, name: "Eternal Coin", tapsRequired: 500000000, reward: 35000000000 },
  { level: 32, name: "Celestial Core", tapsRequired: 600000000, reward: 42000000000 },
  { level: 33, name: "Stellar Coin", tapsRequired: 720000000, reward: 50000000000 },
  { level: 34, name: "Void Relic", tapsRequired: 850000000, reward: 60000000000 },
  { level: 35, name: "Astral Coin", tapsRequired: 1000000000, reward: 70000000000 },
  { level: 36, name: "Infinity Core", tapsRequired: 1200000000, reward: 85000000000 },
  { level: 37, name: "Multiverse Coin", tapsRequired: 1500000000, reward: 100000000000 },
  { level: 38, name: "Genesis Core", tapsRequired: 2000000000, reward: 120000000000 },
  { level: 39, name: "Absolute", tapsRequired: 3000000000, reward: 150000000000 },
  { level: 40, name: "Moneta Origin", tapsRequired: 5000000000, reward: 200000000000 }
];

// Get current level based on total taps
export function getCurrentLevel(totalClicks) {
  for (let i = LEVELS_CONFIG.length - 1; i >= 0; i--) {
    if (totalClicks >= LEVELS_CONFIG[i].tapsRequired) {
      return LEVELS_CONFIG[i];
    }
  }
  return LEVELS_CONFIG[0]; // Level 1 if no taps
}

// Get progress for current level
export function getLevelProgress(totalClicks) {
  const currentLevel = getCurrentLevel(totalClicks);
  const nextLevel = LEVELS_CONFIG.find(level => level.level === currentLevel.level + 1);
  
  if (!nextLevel) {
    // Max level reached
    return {
      currentLevel,
      progress: 100,
      currentTaps: totalClicks - currentLevel.tapsRequired,
      tapsNeeded: 0
    };
  }
  
  const levelStart = currentLevel.tapsRequired;
  const levelEnd = nextLevel.tapsRequired;
  const tapsInLevel = totalClicks - levelStart;
  const tapsRequired = levelEnd - levelStart;
  const progress = Math.min(100, Math.max(0, (tapsInLevel / tapsRequired) * 100));
  
  return {
    currentLevel,
    progress,
    currentTaps: tapsInLevel,
    tapsNeeded: tapsRequired
  };
}

// Check if level up condition is met
export function shouldLevelUp(totalClicks) {
  const currentLevel = getCurrentLevel(totalClicks);
  const nextLevel = LEVELS_CONFIG.find(level => level.level === currentLevel.level + 1);
  
  if (!nextLevel) return false;
  
  return totalClicks >= nextLevel.tapsRequired;
}

// Get reward for level up
export function getLevelUpReward(totalClicks) {
  const currentLevel = getCurrentLevel(totalClicks);
  const nextLevel = LEVELS_CONFIG.find(level => level.level === currentLevel.level + 1);
  
  if (!nextLevel || nextLevel.reward === 0) return 0;
  
  return nextLevel.reward;
}